import { useQuery } from '@tanstack/react-query';
import { mapAttributesToMcpAttributes } from '@printdeal/transformers';

import { ErrorManagement } from '@printdeal/error-management/react';
import LineItem from '../types/cart/LineItem';
import { ServiceFactory } from '../services/ServiceFactory';

const useProductValidation = (lineItem: LineItem, isEnabled: boolean = true) => {
  const { productKey, variableAttributes } = lineItem.custom.fields;
  const validationServiceClient = ServiceFactory.createValidationService();

  return useQuery({
    queryKey: ['validate-product', productKey, JSON.stringify(variableAttributes)],
    queryFn: async () => {
      try {
        const validationResult = await validationServiceClient.validate(
          productKey,
          mapAttributesToMcpAttributes(variableAttributes),
          {},
        );

        return validationResult.data;
      } catch (error) {
        ErrorManagement.exception({
          exception: error,
          extra: {
            productKey,
            variableAttributes: JSON.stringify(variableAttributes),
          },
          tags: {
            fileLocation: 'useProductValidation',
            featureFunction: 'useProductValidation',
          },
          fingerprint: ['hooks-use-product-validation'],
        });

        throw (error);
      }
    },
    enabled: isEnabled,
    gcTime: 1000,
  });
};

export default useProductValidation;
